import * as React from 'react';
import classNames from 'classnames';
import FieldGroup from '../FieldGroup';

export interface IFormListItemProps {
    /** Label to display */
    label?: React.ReactNode;
    /** label element for attribute */
    labelFor?: string;
    /** Error to display */
    error?: React.ReactNode;
    /** Show error icon */
    showErrorIcon?: boolean;
    /** Description text to display */
    description?: React.ReactNode;
    /** Display text value instead of children */
    value?: React.ReactNode;
    /** Mark row as required */
    required?: boolean;
    /** Place asterisk to label */
    requiredPosition?: 'label';
    children?: React.ReactNode;
    /** Path to assets */
    assetBasePath?: string;
    /** Display as fieldgroup */
    isFieldSet?: boolean;
    isCheckboxes?: boolean;
    /** Display separation border */
    isSeparated?: boolean;
    /** Display in columns */
    isSplit?: boolean;
    /** Additional classnames */
    className?: string;
}
/**
 * Single form row for List
 */
export const FormListItem: React.FunctionComponent<IFormListItemProps> = (props: IFormListItemProps) => {
    const required = <span className="text-intent-danger">*</span>;

    const renderContent = () => {
        return (
            <React.Fragment>
                <div className={classNames(
                    props.className,
                    {
                        'form-row-items': !props.isFieldSet,
                    }
                )}>
                    {props.value !== undefined ? (
                        <div className="form-row-value">{props.value ? props.value : '-'}</div>
                    ) : (
                        props.children
                    )}
                </div>
                {((!!props.error && typeof props.error !== 'boolean') || !!props.description) && (
                    <div className="form-row-instructions">
                        {props.error && (
                            <React.Fragment>
                                {props.showErrorIcon && (
                                    <img src={`${props.assetBasePath ?? 'assets/img/'}/icon_error.svg`} alt="!" />
                                )}
                                <span>{props.error}</span>
                            </React.Fragment>
                        )}
                        {props.description && <div className="form-row-description"><span>{props.description}</span></div>}
                    </div>
                )}
            </React.Fragment>
        );
    };

    return (
        <li
            className={classNames({
                error: props.error,
                separated: props.isSeparated,
                split: props.isSplit
            })}
        >
            {props.isFieldSet ? (
                <FieldGroup label={props.label} required={props.required} isCheckboxes={props.isCheckboxes}>
                    {renderContent()}
                </FieldGroup>
            ) : (
                <React.Fragment>
                    {!!props.label && (
                        <label className="form-row-label" htmlFor={props.labelFor ?? ''}>
                            {props.label}
                            {props.required && required}
                        </label>
                    )}
                    {props.required && !props.label && required}
                    {renderContent()}
                </React.Fragment>
            )}

        </li>
    );
};
export default FormListItem;
